import { LIVE_INIT, LIVE_UPDATE, LIVE_MATCH_INIT, LIVE_MATCH_UPDATE, TIMETABLE_INIT, TIMETABLE_UPDATE } from '../../sagas/actions';
import * as LiveActions from '../../actions/live';
import { CHANGE_LOCALE } from '../../actions/locale';
export default function versionReducer(version, action) {
    switch (action.type) {
        case LIVE_INIT.FAILURE:
        case LIVE_MATCH_INIT.FAILURE:
        case LIVE_UPDATE.FAILURE:
        case LIVE_MATCH_UPDATE.FAILURE:
        case TIMETABLE_INIT.FAILURE:
        case TIMETABLE_UPDATE.FAILURE:
        case LiveActions.CLEAR_LIVE:
        case LiveActions.CLEAR_LIVE_MATCH:
        case CHANGE_LOCALE:
            return 0;
        case LIVE_INIT.SUCCESS:
        case LIVE_MATCH_INIT.SUCCESS:
        case LIVE_UPDATE.SUCCESS:
        case LIVE_MATCH_UPDATE.SUCCESS:
        case TIMETABLE_INIT.SUCCESS:
        case TIMETABLE_UPDATE.SUCCESS:
            return action.data.version;
    }
    return version;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/versionReducer.js